import { FixedType } from 'rc-table/lib/interface';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Column, ColumnHeader } from '../components/common';
import { useDataGridContext } from '../context';
import { strIsNullOrEmpty } from '@fox/atoms';
import { TableStyleProps } from '..';
import { filterColumnsForPosition, useFixedColumnStyles } from '../helpers';

interface FixedColumnProps {
	position: FixedType;
	hideColumnBorders?: boolean;
	tableStyle?: TableStyleProps;
}

export const FixedHeaderColumns: React.FC<FixedColumnProps> = ({ position, hideColumnBorders, tableStyle }) => {
	const { columns } = useDataGridContext();
	const theme = useContext(ThemeContext);
	const columnsForPosition = filterColumnsForPosition(columns, position);
	const columnStyles = useFixedColumnStyles(position);
	if (!columnsForPosition?.length) {
		return null;
	}
	let left = 0;

	return (
		<>
			{columnsForPosition?.map((column, columnIndex) => {
				const colStyle = position === 'left' ? { ...columnStyles, left } : columnStyles;
				left += Number(column.width);
				return (
					<Column
						key={
							!strIsNullOrEmpty(column?.dataIndex)
								? `${column.dataIndex}-${columnIndex}`
								: `fixedColumnHeader: ${columnIndex}-${columnIndex}`
						}
						style={{ ...colStyle, backgroundColor: theme?.colors.grey?.[200] }}
						$width={column.width}
						$hideColumnBorders={hideColumnBorders}
					>
						<ColumnHeader
							style={{
								width: column.width
							}}
							$hideColumnBorders={hideColumnBorders}
							$backgroundColor={tableStyle?.headerColour}
							className={column.fixed ? `${column.fixed}` : `dragHandle`}
						>
							{column.title}
						</ColumnHeader>
					</Column>
				);
			})}
		</>
	);
};
